const d3 = Object.assign({}, require('d3-format'))

export const locale = d3.formatLocale({
  decimal: ',',
  thousands: ' ',
  grouping: [3]
})
// create a string of numbers that roughly updates once every day to ensure old data is not pulled (where needed)
export const bust = () => {
  return Math.floor(Date.now() / 86400000) + ''
}

// slugs may be used and may be localized. We track them here for sanity
export const slugToRegion = slug => {
  return slugs[slug]
}
const slugs = {
  amazonas: 'amazonas',
  africa: 'africa',
  asia: 'asia',
  'sentral-afrika': 'africa',
  'asia-oseania': 'asia',
  'asia-oceania': 'asia',
  'central-africa': 'africa'
}

export const slugToLanguage = d => {
  return languageDimensions[d]
}
const languageDimensions = {
  skogdekke: 'no',
  skogtap: 'no',
  skogbrann: 'no',
  forestcover: 'en',
  forestloss: 'en',
  forestfire: 'en'
}

export const slugToDimension = d => {
  return dimensions[d]
}
const dimensions = {
  skogdekke: 'forestCover',
  skogtap: 'forestLoss',
  skogbrann: 'fire',
  forestcover: 'forestCover',
  forestloss: 'forestLoss',
  forestfire: 'fire'
}

export const dimensionToSlug = (dimension, language) => {
  return dimensionSlugs[language][dimension]
}

const dimensionSlugs = {
  en: {
    forestCover: 'forestcover',
    forestLoss: 'forestloss',
    fire: 'forestfire'
  },
  no: {
    forestCover: 'skogdekke',
    forestLoss: 'skogtap',
    fire: 'skogbrann'
  }
}

export const regionToName = (region, language) => {
  return regionNames[language][region]
}

const regionNames = {
  en: {
    amazonas: 'The Amazon',
    africa: 'Central Africa',
    asia: 'Asia and Oceania'
  },
  no: {
    amazonas: 'Amazonas',
    africa: 'Sentral-Afrika',
    asia: 'Asia og Oseania'
  }
}

export const regionToSlug = (region, language) => {
  return regionSlugs[language][region]
}

const regionSlugs = {
  en: {
    amazonas: 'amazonas',
    africa: 'central-africa',
    asia: 'asia-oceania'
  },
  no: {
    amazonas: 'amazonas',
    africa: 'sentral-afrika',
    asia: 'asia-oceania'
  }
}

export const toMapRegion = d => {
  return mapRegion[d] || d
}

const mapRegion = {
  amazonas: 'soramerika',
  africa: 'afrika',
  asia: 'asia',
  'sentral-afrika': 'afrika',
  'asia-oseania': 'asia'
}

export const dimensionToDownloadUrl = (dimension, location) => {
  return urlRegion[dimension](location)
}

const urlRegion = {
  forestCover: l => `forestcover/cover_${l}.csv`,
  forestLoss: l => `deforestation/${l}_timeline.csv`,
  fire: l => `forestfire/${l}_timeline.csv`
}
